/**
 * X (Twitter) Pixel ID，取自 Ads Manager → Events Manager 的 base code。
 * 仅在 Next 侧注入，未覆盖 public/ 下的营销静态页；若广告落地页改到那些页面需另行装载。
 */
export const X_PIXEL_ID = 're1bd';

/**
 * 转化事件 ID，格式为 tw-{pixelId}-{eventId}。
 * 同一像素下的事件 ID 仅末位不同，复制粘贴时极易混淆，改动前请与 Events Manager 逐字核对。
 */
export const X_PURCHASE_EVENT_ID = `tw-${X_PIXEL_ID}-re38e`;
export const X_SIGNUP_EVENT_ID = `tw-${X_PIXEL_ID}-re38f`;
